export const VERIFY_OTP_ACTION = 'VERIFY_OTP_ACTION';
export const VERIFY_OTP_SUCCESS_ACTION = 'VERIFY_OTP_SUCCESS_ACTION';
export const VERIFY_OTP_FAILURE_ACTION = 'VERIFY_OTP_FAILURE_ACTION';
